import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';
import { emphasizedTextFragment } from '../EmphasizedText';
import { fragments as tileFragments } from '../Tile';

export const immersiveScrollBlockFragment = gql`
  fragment ImmersiveScrollBlockAll on ImmersiveScrollBlock {
    ...ContentfulSysId
    eyebrow
    title {
      json
      links {
        entries {
          inline {
            ...ContentfulSysId
            ... on EmphasizedText {
              ...EmphasizedTextAll
            }
          }
        }
      }
    }
    text
    tilesCollection(limit: 4) {
      items {
        ...ContentfulSysId
        ...ImmersiveScrollBlockTile
      }
    }
    tilesDirection
    textAlignmentMobile
    brandBackgroundColor
    backgroundColor
    anchor
  }
  ${contentfulSysIdFragment}
  ${emphasizedTextFragment}
  ${tileFragments.immersiveScrollBlockTile}
`;

export const immersiveScrollBlockQuery = gql`
  query ImmersiveScrollBlockQuery($preview: Boolean!, $locale: String!, $id: String!) {
    immersiveScrollBlock(preview: $preview, locale: $locale, id: $id) {
      ...ImmersiveScrollBlockAll
    }
  }
  ${immersiveScrollBlockFragment}
`;
